import React from 'react'
import injectSheet from 'react-jss'
import styles from './work-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
import CircleStatus from 'pobble-components/dist/circle-status'
import ContextMenu from './context-menu/context-menu.container'
import Tooltip from 'pobble-components/dist/tooltip'
import AgeGroup from 'pobble-components/dist/age-group'
import { BulkCheckbox } from 'pobble-components/dist/bulk-action'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'

const WorkEntry = ({
  classes,
  date,
  title,
  id,
  published,
  link,
  ageOrder,
  ageTitle,
  pending,
  thumbnail,
  independent,
  independentInfo
}) => (
  <TableRow pending={pending}>
    <Cell center>
      <BulkCheckbox id={id} />
    </Cell>
    <Cell>{date}</Cell>
    <Cell className={classes.thumbnail}>
      <a href={link}>
        <span style={{ backgroundImage: `url("${thumbnail}")` }} />
      </a>
    </Cell>
    <Cell>
      <a href={link} className={classes.titleLink}>
        {title}
      </a>
    </Cell>
    <Cell center>
      {!independent && 'N/A'}
      {independent === 'yes' && 'Yes'}
      {independent === 'no' && 'No'}
      {independent === 'in_part' && (
        <Tooltip content={independentInfo}>
          <span className={classes.inPart}>
            In part <FontAwesomeIcon icon={faInfoCircle} />
          </span>
        </Tooltip>
      )}
    </Cell>
    <Cell center>
      <AgeGroup order={ageOrder}>{ageTitle}</AgeGroup>
    </Cell>
    <Cell center>
      <Tooltip
        content={published ? 'Work is published' : 'Work is not published'}>
        <CircleStatus status={published} />
      </Tooltip>
    </Cell>
    <Cell right>
      <ContextMenu id={id} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(WorkEntry)
